/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DateOnlyFormats {
    ShortDate = 1,
    LongDate = 2,
    LongDateShortMonth = 12,
}
